export const VIDEO_TYPE = 'LEARNING_CENTER.VIDEO';
export const ARTICLE_TYPE = 'LEARNING_CENTER.ARTICLE';
